import React from "react";

export default (props) => <tbody {...props.style}>{props.children}</tbody>;
